import React from "react";
import Link from "@qlik/qlik/src/components/Link";
import Media from "@qlik/qlik/src/components/Media";
import { renderSanitizedHtmlContent } from "@qlik/qlik/src/lib/util/helpers";
import { leadershipTranslations } from "@qlik/qlik/src/translations/leadership";
import { useI18n } from "@qlik/utils/i18nContext";

/**
 * SingleCardLeadership component.
 * Renders a single card with a title, subtitle, image, and link.
 * @param {Object} props - The component props.
 * @param {string} props.title - The title of the card.
 * @param {string} props.subtitle - The subtitle of the card.
 * @param {string} props.image - The image for the card.
 * @param {string} props.link - The link for the card.
 */

const SingleCardLeadership = ({ title, subtitle, image, link }) => {
    const { i18n } = useI18n();

    // get the translated text, and if it's not available, default to the english
    const translations = leadershipTranslations[i18n?.curr?.contentfulCode ?? "en"];

    return (
        <div className="flex h-full flex-col border-b border-gray/25 hover:border-green">
            {link && (
                <Link className="group hover:no-underline list-none block mb-4.5" to={link}>
                    <div className="flex-1">
                        {image && (
                            <Media
                                media={image}
                                className=" w-full aspect-[370/268] object-cover mb-7.5 object-left rounded"
                            />
                        )}
                        {title && <h3 className="mb-2.5 title-4">{title}</h3>}
                        {subtitle && (
                            <p
                                className="text-stone mb-4.75"
                                // eslint-disable-next-line react/no-danger
                                dangerouslySetInnerHTML={{ __html: renderSanitizedHtmlContent(subtitle) }}
                            />
                        )}
                    </div>
                    <p className="green-link lg:group-hover:text-dark-green lg:group-hover:after:arrow-green-dark lg:group-hover:after:translate-x-0.75">
                        {translations["viewBio"]}
                    </p>
                </Link>
            )}
        </div>
    );
};

export default SingleCardLeadership;
